import { Box, Skeleton } from "@mui/material";

const SummarySkeleton = () => {
  return (
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
      {/* Placeholder for image */}
      <Skeleton
        variant="rectangular"
        width={100}
        height={100}
        sx={{ flexShrink: 0 }}
      />

      {/* Placeholder for text content */}
      <Box sx={{ flex: 1 }}>
        {/* Name */}
        <Skeleton variant="text" width="50%" height={32} />

        {/* Title and organization */}
        <Skeleton variant="text" width="40%" height={24} />
        <Skeleton variant="text" width="60%" height={24} sx={{ mb: 2 }} />

        {/* Simulated paragraph */}
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="95%" />
        <Skeleton variant="text" width="98%" />
        <Skeleton variant="text" width="90%" />
        <Skeleton variant="text" width="85%" />
        <Skeleton variant="text" width="92%" />
      </Box>
    </Box>
  );
};

export default SummarySkeleton;
